import {
  logout as logoutServices,
  login as loginServices,
  register as registerServices,
  verifyAccount as verifyServices,
  changePassword as changePasswordServices,
  checkAuth as checkAuthServices,
  preActiveAccount as preActiveAccountServices,
  activeAccount as activeAccountServices,
  resetPassword as resetPasswordServices,
  otpRegister as otpRegisterServices,
  otpRegisterVerify as otpRegisterVerifyServices,
  checkSession as checkSessionServices,
  otpTicketVerify as otpTicketVerifyServices,
  applySelfDefinedUserId as applySelfDefinedUserIdServices,
  identityType as identityTypeServices,
  bcanStatus as bcanStatusServices,
  bcanConsent as bcanConsentServices,
  accountDetail as accountDetailServices,
  bankAccountRegister as bankAccountRegisterServices,
  accepRegisterEdda as accepRegisterEddaServices,
  acceptAccountDetails as acceptAccountDetailsServices,
} from '../../services/auth-services';
import { PARAMS } from '@/constants/params';
import { getAssetAllocation } from '../trading/account.actions'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { AUTH_ACTION as types, USER as iUser } from '../../constants/auth';
import { APP_SETTING_ACTION as appTypes, APP_MODE_TYPE } from '../../constants/app';
import { SERVICES_RESP as servicesResp, appEnvironment, history } from '../../configurations';
import { getSafeStorage, saveSafeStorage, removeFromStorage, checkFullLayoutRedirect, checkIsTabs } from '../../helpers/global';
import { STORAGE_KEY as storageKey } from '../../constants/storage.key';
import { PARAMS as rqParams } from '../../constants/params';
import { winVestLoginAction, winVestViewCustomerAction, winVestLogoutAction } from './auth.win-vest.action';
import { getTradingAccount, getCashAccount } from '../trading';
import { stockActions } from '../trading/stock.action';
import { userActions } from '../user';
import { USER_ACTION as userTypes } from '../../constants/user';
import { actionType } from '../../constants/action-type';
import { PATH } from '../../constants/paths';
import { saveWinVestUserLanguage } from '../app';
import { I_TRADE_ACTION } from '../../constants/i-trade'
import stockServices from '@/actions/trading'
import { utilsFunction, Filter } from "../../helpers/functions";


export const loginAction = (params, callback) => {
  return dispatch => {
    if (getSafeStorage(storageKey.TOKEN)) {
      dispatch(handleAuthData(null, actionType.RESET));
    }
    loginServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK || returnedServices.result.errorCode === servicesResp.SYSTEM_NOT_AVAILABLE) {
        callback(returnedServices.result)
        if (returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
          saveSafeStorage(storageKey.T_ACCOUNT, '');
          dispatch(handleAuthData(returnedServices.result, actionType.NEW));
        }
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const registerAction = (params, callback) => {
  return (dispatch, getState) => {
    registerServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        let respData = returnedServices.result;
        if (respData.errorCode === servicesResp.SUCCESS_CODE) {
          saveSafeStorage(storageKey.WIN_VEST_ACCESS_TOKEN, respData.apiaccessToken);
          dispatch(winVestLoginAction({ [rqParams.TOKEN]: respData.apiaccessToken }, res => {
            respData = Object.assign(respData, res)
            callback(respData)
            saveWinVestUserLanguage(res)(dispatch, getState)
            dispatch({
              type: userTypes.GET_USER_INFO,
              userInfo: {
                id: res.id,
                profile: res.profile,
                user_pref: res.user_pref,
                default_sub_trading_acc: res.default_sub_trading_acc
              }
            })
          }))
        } else {
          callback(respData)
        }
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const logoutAction = (params, callback) => {
  return (dispatch, getState) => {
    logoutServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK || params.hideError) {
        dispatch(winVestLogoutAction());
        dispatch(handleAuthData(returnedServices.result, actionType.RESET));
        dispatch({
          type: I_TRADE_ACTION.GET_QUOTE_DETAIL,
          quoteDeatil: { bidData: Array(5).fill({ price: "-", qty: "-" }), askData: Array(5).fill({ price: "-", qty: "-" }) },
        });
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
      // Fixed an issue with session expiration Windows constantly popping up
      const { isAuthenticated } = getState().auth
      if (isAuthenticated) {
        dispatch({
          type: types.LOGOUT,
          isAuthenticated: false,
          loginID: '',
          isVerifiedAccount: true,
          user: {},
          token: null,
          tradingAccount: {}
        })
      }
      checkFullLayoutRedirect();
    })
  }
}

export const preActiveAccountAction = (params, callback) => {
  return dispatch => {
    preActiveAccountServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const activeAccountAction = (params, callback) => {
  return dispatch => {
    activeAccountServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
        if (returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
          dispatch({
            type: types.ACTIVE_ACCOUNT,
            isVerifiedAccount: true
          })
        }
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const verifyAccountAction = (params, callback) => {
  return dispatch => {
    verifyServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const changePasswordAction = (params, callback) => {
  return dispatch => {
    changePasswordServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const checkRunMode = () => {
  return (dispatch, getState) => {
    const currentMode = getState().app.mode
    const params = utilsFunction.getAllUrlParams(location.search)
    const { mode } = params

    if (typeof mode === 'string' && APP_MODE_TYPE[mode.toLocaleUpperCase()] && mode !== currentMode) {
      dispatch({ type: appTypes.SWITCH_MODE, mode })
    }
  }
}

export const checkAuthAction = (isCheckInterval = false, callback = () => { }) => {
  return async (dispatch, getState) => {
    const isNotTabs = await checkIsTabs()
    if (isNotTabs) {
      const token = getSafeStorage(storageKey.TOKEN)
      if (token) {
        checkAuthServices({}, returnedServices => {
          if (returnedServices.status === servicesResp.STATUS_OK) {
            if (returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
              if (returnedServices.result.needChangePassword === 'Y') {
                history.push(PATH.CHANGE_PW)
              }
              if (!isCheckInterval) {
                dispatch(handleAuthData(returnedServices.result, actionType.NEW, true));
              }
            } else {
              if (!isCheckInterval) {
                dispatch(handleAuthData(returnedServices.result, actionType.RESET));
                checkFullLayoutRedirect();
              }
            }
            callback(returnedServices);
          } else {
            dispatch(handleAuthData(returnedServices.result, actionType.RESET));
            checkFullLayoutRedirect();
            // const toast = {
            //   type: 'error',
            //   autoClose: true,
            //   errorCode: returnedServices.status,
            //   isOpen: false
            // }
            // dispatch({
            //   type: appTypes.SHOW_TOAST,
            //   toast: toast
            // })
          }
        })
      } else {
        checkFullLayoutRedirect();
      }
    } else {
      history.push(PATH.MORE_TAB)
    }
  }
}

export const resetPasswordAction = (params, callback) => {
  return dispatch => {
    resetPasswordServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const otpRegisterAction = (params, callback) => {
  return dispatch => {
    otpRegisterServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const otpRegisterVerifyAction = (params, callback) => {
  return dispatch => {
    otpRegisterVerifyServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const handleAuthData = (data, action, actionflag = false) => {
  if (action === actionType.NEW) {
    saveSafeStorage(storageKey.TOKEN, data.token);
    if (iTradeEnv?.apis?.winvestorApi) {
      saveSafeStorage(storageKey.WIN_VEST_ACCESS_TOKEN, data.apiaccessToken);
    }
    saveSafeStorage(storageKey.USER, JSON.stringify(data));
    return (dispatch, getState) => {
      // GET TRADING ACCOUNTS
      const params = {
        loginID: data.loginID
      }
      if (getSafeStorage(storageKey.TRADE_ACCOUNT)) {
        let ctradeAccount = getSafeStorage(storageKey.T_ACCOUNT) ? Filter.filterCurrentSubAccount(JSON.parse(getSafeStorage(storageKey.TRADE_ACCOUNT)).tradingAccounts, getSafeStorage(storageKey.T_ACCOUNT)) : ''
        dispatch({
          type: I_TRADE_ACTION.GET_TRADING_ACCOUNT,
          tradingAccounts: ctradeAccount ? ctradeAccount : JSON.parse(getSafeStorage(storageKey.TRADE_ACCOUNT)).tradingAccounts,
          clientID: JSON.parse(getSafeStorage(storageKey.TRADE_ACCOUNT)).clientID
        })
        if (iTradeEnv?.actions?.trading?.getCashAccount) {
          dispatch(getCashAccount())
        }
      } else {
        if (data.token) {
          dispatch(getTradingAccount(params, res => {
            //   // TODO
          }))
        }
      }
      dispatch({
        type: I_TRADE_ACTION.STOP_QUTO_REFRESH,
        stopQutoRefresh: 'false'
      })
      dispatch({
        type: types.LOGIN,
        isAuthenticated: true,
        loginID: data.loginID,
        tradingAccount: data.listTradingAccount.filter(data => data.isDefault)[0],
        isVerifiedAccount: data.status === iUser.ACTIVE_STATE ? true : false,
        user: data,
        token: data.token,
        lastLoginTime: data.lastLoginTime,
        aastockClientId: data.external.aastockClientId,
        username: data.username
      });
      if (iTradeEnv.apis?.mdsApi) {
        dispatch(stockActions.loginMDSAction(data.external.aastockClientId || data.loginID))
      }
      dispatch(winVestLoginAction({ [rqParams.TOKEN]: data.apiaccessToken }, res => {
        if (res) {
          saveSafeStorage(storageKey.WIN_VEST_SESSION, res.sessid);
          saveSafeStorage(storageKey.WIN_VEST_SESSION_NAME, res.session_name);
          const wParams = {
            [rqParams.ID]: res.id
          }
          const userInfo = { id: res.id, user_pref: res.user_pref, default_sub_trading_acc: res.default_sub_trading_acc, profile: {} }
          saveWinVestUserLanguage(userInfo)(dispatch, getState)
          dispatch({ type: userTypes.GET_USER_INFO, userInfo })
          // TO TO
          dispatch(winVestViewCustomerAction(wParams, resp => {
            userInfo.profile = resp
            dispatch({
              type: userTypes.GET_USER_INFO,
              userInfo
            })
          }))
        }
      }))

      // dispatch(stockActions.getMarketAction({}, res => {
      //   // TO DO
      // }))
      // dispatch(userActions.getWatchlistAction({}, res => {
      //   // TO DO
      // }))
    }
  } else {
    return dispatch => {
      removeFromStorage(storageKey.WIN_VEST_CSRF_TOKEN);
      removeFromStorage(storageKey.WIN_VEST_SESSION);
      removeFromStorage(storageKey.WIN_VEST_SESSION_NAME);
      removeFromStorage(storageKey.TOKEN);
      removeFromStorage(storageKey.WIN_VEST_ACCESS_TOKEN);
      removeFromStorage(storageKey.USER);
      removeFromStorage(storageKey.TRADE_ACCOUNT);
      if (iTradeEnv.apis?.mdsApi) {
        dispatch(stockActions.logoutMDSAction())
        dispatch({ type: I_TRADE_ACTION.SET_MDS_TOKEN, mdsToken: '' })
        dispatch({ type: I_TRADE_ACTION.SET_QUOTE_ACCOUNT, mdsToken: {} })
      }
      dispatch({
        type: types.LOGOUT,
        isAuthenticated: false,
        loginID: '',
        isVerifiedAccount: true,
        user: {},
        token: null,
        tradingAccount: {}
      })
      dispatch({
        type: userTypes.GET_USER_INFO,
        userInfo: {}
      })
      dispatch({
        type: I_TRADE_ACTION.CLEAR_TRADING_ACCOUNT,
      })
      dispatch({
        type: I_TRADE_ACTION.GET_POSITION_DATA,
        portfolios: []
      })
      dispatch({
        type: I_TRADE_ACTION.SET_CURRENT_MARKET,
        currentMarket: 'HKEX'
      })
      dispatch({
        type: appTypes.TOGGLE_MENU_MOBILE,
        isOpenMenuMobile: false
      })
    }
  }
}

export const resetAuthAction = () => {
  return dispatch => dispatch(handleAuthData(null, { actionType: actionType.RESET }))
}

export const applySelfFDefinedUserIdAction = (params, callback) => {
  return dispatch => {
    applySelfDefinedUserIdServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices)
        if (returnedServices.status === servicesResp.SUCCESS_CODE) {
          dispatch({
            type: types.LOGIN,
            username: params.username
          })
        }
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const checkSessionAction = (params, callback, failCallback) => {
  return () => {
    checkSessionServices(params, callback, failCallback)
  }
}

export const otpTicketVerifyAction = (params, callback) => {
  return dispatch => {
    otpTicketVerifyServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
        dispatch(handleAuthData(returnedServices.result, actionType.NEW));
      } else {
        const toast = {
          type: 'error',
          autoClose: true,
          errorCode: returnedServices.status,
          isOpen: false
        }
        dispatch({
          type: appTypes.SHOW_TOAST,
          toast: toast
        })
      }
    })
  }
}

export const getIdentityTypeAction = (callback) => {
  const params = {
    itemType: 'IDTYPE',
    name: '',
    value: ''
  }
  const itemList = []
  return dispatch => {
    identityTypeServices(params, res => {
      if (res.status === servicesResp.STATUS_OK) {
        res.result.itemList.map(item => {
          itemList.push({ label: item.name, value: item.value })
        })
        dispatch({
          type: appTypes.IDTYPE_LIST,
          idTypeList: itemList
        })
      } else {

      }
    })
  }
}

export const bcanStatusAction = (params, callback) => {
  return () => {
    bcanStatusServices(params, callback)
  }
}

export const bcanConsentAction = (params, callback) => {
  return () => {
    bcanConsentServices(params, callback)
  }
}

export const accountDetailAction = (params, callback) => {
  return () => {
    accountDetailServices(params, callback);
  };
};

export const bankAccountRegisterAction = (params, callback) => {
  return () => {
    bankAccountRegisterServices(params, callback);
  };
};

export const registerEddaAction = (params, callback) => {
  return () => {
    accepRegisterEddaServices(params, callback);
  };
};

export const getAccountDetailsAction = (params, callback) => {
  return () => {
    acceptAccountDetailsServices(params, callback);
  };
};